export const pickAccountCurrency = (accountInfo: unknown): string | null => {
	if (!accountInfo || typeof accountInfo !== 'object') return null;

	const info = accountInfo as Record<string, unknown>;
	const currency = info.currency;

	if (!currency) return null;

	const currencyName = (currency as Record<string, unknown>).name as string | null;
	return currencyName;
};
